import ActionForms from '@/shared/mixins/actionsForm'
import addFolderForm from './addfolder-form'
import addFolderModel from '@/shared/models/business/gedfoldermodel'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'
import GroupRepository from '@/shared/http/repositories/access/group'
import AccountRepository from '@/shared/http/repositories/access/account'
import GedTagRepository from '@/shared/http/repositories/business/gedtag'
import { loading, toast } from '@/shared/utils/UIHelper'
import FolderPermission from '@/shared/utils/folderPermission'
import AccountMixin from '@/store/module/account/mixin'
import DocMixin from '../../mixins/DocMixin'

export default {
  name: 'AddFolder',
  mixins: [DocMixin, ActionForms, AccountMixin],
  props: ['value'],
  created () {
    this.onLoadAllTypes()
    this.onLoadAllSubjects()
    this.onLoadAllGroups()
    this.onLoadAllAccounts()
    this.onLoadAllChecklists()
    this.onLoadAllTags()
    this.form.seguranca.options = [
      {text: this.$lang.Documents.Folder.LabelPublic, value: false},
      {text: this.$lang.Documents.Folder.LabelPrivate, value: true}
    ]
  },
  data () {
    return {
      form: addFolderForm,
      data: addFolderModel,
      objSelected: null,
      gedFolderGroups: [],
      gedFolderAccounts: [],
      groupOptions: [],
      accountOptions: [],
      folderPermission: FolderPermission,
      selectedTags: []
    }
  },
  methods: {
    edit (folder) {
      this.gedFolderGroups = folder.gedPastaGrupos || []
      this.gedFolderGroups.forEach(f => this.setPermissions(f))

      this.gedFolderAccounts = folder.gedPastaContas || []
      this.gedFolderAccounts.forEach(f => this.setPermissions(f))

      this.selectedTags = folder.gedPastaTags ? folder.gedPastaTags.map(f => {
        return this.form.gedTagID.options.filter(op => op.value === f.gedTagID)[0]
      }) : []

      this.form.propagar.value = false

      this.onEdit(folder)
    },
    onLoad () {
      let value = {
        nome: 'Nova Pasta',
        seguranca: false,
        gedPastaGrupos: [],
        gedPastaContas: [],
        gedPastaTags: [],
        gedTipoID: null,
        gedAssuntoID: null,
        gedChecklistID: null
      }

      if (this.value) {
        value.seguranca = this.value.seguranca
        value.gedTipoID = this.value.gedTipoID
        value.gedAssuntoID = this.value.gedAssuntoID
        value.gedChecklistID = this.value.gedChecklistID
        value.gedPastaPaiID = this.value.gedPastaPaiID
        value.gedPastaGrupos = this.value.gedPastaGrupos ? this.value.gedPastaGrupos.map(f => {
          f.id = f.id ? f.id : '00000000-0000-0000-0000-000000000000'
          f.gedPastaID = this.value.id
          return f
        }) : []
        value.gedPastaContas = this.value.gedPastaContas ? this.value.gedPastaContas.map(f => {
          f.id = f.id ? f.id : '00000000-0000-0000-0000-000000000000'
          f.gedPastaID = this.value.id
          return f
        }) : []
        value.gedPastaTags = this.value.gedPastaTags ? this.value.gedPastaTags.map(f => {
          f.id = f.id ? f.id : '00000000-0000-0000-0000-000000000000'
          f.gedPastaID = this.value.id
          return f
        }) : []
      }
      this.edit(value)
    },
    onBack () {
      this.$emit('Back', this.data)
    },
    onCreate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      this.data.contaAutorID = this.account.id

      this.setPermissionsInData()

      GedFolderRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.$emit('Create', response.data.data)
          } else {
            toast.error(this.$lang.Common.ActionNotTaken)
          }
          loading.close()
        })
        .catch(err => this.onException(err))
    },
    onUpdate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      this.data.status = parseInt(this.data.status)

      this.setPermissionsInData()

      this.data.gedPastaTags = this.data.gedPastaTags.filter(t => {
        return this.selectedTags.some(op => op.value === t.gedTagID)
      })
      const listToAdd = this.selectedTags.filter(op => op.value && !this.data.gedPastaTags.some(tg => tg.gedTagID === op.value))
      if (listToAdd.length) {
        this.data.gedPastaTags.push(...listToAdd.map(op => {
          return {
            id: '00000000-0000-0000-0000-000000000000',
            gedPastaID: this.data.id,
            gedTagID: op.value,
            status: 1
          }
        }))
      }

      const doUpdate = () => {
        let promises = [Promise.resolve()]

        this.selectedTags.filter(op => !op.value).forEach(op => {
          const data = {
            id: '00000000-0000-0000-0000-000000000000',
            nome: op.text,
            status: 1
          }
          promises.push(
            GedTagRepository.Create(data)
              .then(response => {
                if (response.data.code > 0) {
                  this.data.gedPastaTags.push({
                    id: '00000000-0000-0000-0000-000000000000',
                    gedPastaID: this.data.id,
                    gedTagID: response.data.data.id,
                    status: 1
                  })
                  this.form.gedTagID.options.push({
                    text: response.data.data.nome,
                    value: response.data.data.id
                  })
                }
              })
          )
        })

        Promise.all(promises)
          .then(() => {
            GedFolderRepository.Update(this.data)
              .then(response => {
                if (response.data.code > 0) {
                  response.data.data.gedPastas = this.data.gedPastas

                  if (this.form.propagar.value) {
                    toast.info(this.$lang.Documents.Folder.LabelPropagationStart)
                    GedFolderRepository.UpdatePropagate(this.data)
                      .then(() => {
                        toast.info(this.$lang.Documents.Folder.LabelPropagationFinish)
                      })
                      .catch(err => {
                        console.log(err)
                        toast.error(this.$lang.Documents.Folder.LabelPropagationError)
                      })
                  }

                  this.$emit('Update', response.data.data)
                } else {
                  toast.error(this.$lang.Common.ActionNotTaken)
                }
                loading.close()
              })
          })
          .catch(err => this.onException(err))
      }

      doUpdate()
    },
    onLoadAllGroups () {
      loading.push()
      GroupRepository.GetAll()
        .then(response => {
          this.groupOptions = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(err => this.onException(err))
    },
    onLoadAllAccounts () {
      loading.push()
      AccountRepository.GetAll()
        .then(response => {
          this.accountOptions = this.onResultDropdown(response, null, f => `${f.nome} (${f.username})`)
        })
        .catch(err => this.onException(err))
    },
    onAddGedFolderGroup () {
      const gedFolderGroup = {
        id: '00000000-0000-0000-0000-000000000000',
        gedPastaID: this.data.id,
        grupoID: null,
        permissao: 0,
        status: 1,
        Read: false,
        Download: false,
        Write: false,
        Delete: false,
        Admin: false
      }

      this.gedFolderGroups.push(gedFolderGroup)
    },
    onDeleteGedFolderGroup (index) {
      this.gedFolderGroups.splice(index, 1)
    },
    onAddGedFolderAccount () {
      const gedFolderAccount = {
        id: '00000000-0000-0000-0000-000000000000',
        gedPastaID: this.data.id,
        contaID: null,
        permissao: 0,
        status: 1,
        Read: false,
        Download: false,
        Write: false,
        Delete: false,
        Admin: false
      }

      this.gedFolderAccounts.push(gedFolderAccount)
    },
    onDeleteGedFolderAccount (index) {
      this.gedFolderAccounts.splice(index, 1)
    },
    onChangePermission (type, obj) {
      this.$set(obj, type, !obj[type])
      this.calcPermission(obj)
    },
    setPermissionsInData () {
      const gedPastaGrupos = this.gedFolderGroups.map(f => {
        return {
          id: f.id,
          grupoID: f.grupoID,
          gedPastaID: this.data.id,
          status: f.status,
          permissao: f.permissao
        }
      })

      this.data.gedPastaGrupos = gedPastaGrupos

      const gedPastaContas = this.gedFolderAccounts.map(f => {
        return {
          id: f.id,
          contaID: f.contaID,
          gedPastaID: this.data.id,
          status: f.status,
          permissao: f.permissao
        }
      })

      this.data.gedPastaContas = gedPastaContas
    },
    setPermissions (obj) {
      this.$set(obj, 'Read', (obj.permissao & 1) > 0)
      this.$set(obj, 'Download', (obj.permissao & 2) > 0)
      this.$set(obj, 'Write', (obj.permissao & 4) > 0)
      this.$set(obj, 'Delete', (obj.permissao & 8) > 0)
      this.$set(obj, 'Admin', (obj.permissao & 16) > 0)
    },
    calcPermission (obj) {
      const permission = 0 +
        (obj.Read ? 1 : 0) +
        (obj.Download ? 2 : 0) +
        (obj.Write ? 4 : 0) +
        (obj.Delete ? 8 : 0) +
        (obj.Admin ? 16 : 0)

      this.$set(obj, 'permissao', permission)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/folder/addfolder.js